export default {"src":"/_next/static/media/sign-in.13e846d3.svg","height":692,"width":649};